import { Box, Typography } from '@mui/material';
import { CaretRight } from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GeneralInformation from '../components/Settings/GeneralInformation';
import Security from '../components/Settings/Security';

const Settings = () => {
  const [selectedTab, setSelectedTab] = useState('general');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.search === '?tab=security') {
      setSelectedTab('security');
    }
  }, [location.search]);

  return (
    <Box padding={'32px 32px 0 32px'}>
      <Typography variant='h1' lineHeight={'1.5'} fontSize={'20px'}>
        Settings
      </Typography>
      <Box
        mt={'42px'}
        display={'flex'}
        sx={{
          '@media (max-width: 900px)': {
            flexDirection: 'column',
          },
        }}
      >
        <Box
          paddingRight={'32px'}
          maxWidth={'260px'}
          width={'100%'}
          height={'calc(100vh - 200px)'}
          borderRight={'1px solid #E3DDE6'}
          sx={{
            '@media (max-width: 900px)': {
              borderRight: 'none',
              borderBottom: '1px solid #E3DDE6',
              height: 'auto',
              display: 'flex',
              mb: '20px',
              maxWidth: '100%',
            },
          }}
        >
          <Typography
            sx={{
              padding: '8px 10px',
              cursor: 'pointer',
              bgcolor: selectedTab === 'general' ? '#E5FAFF' : '',
              borderRadius: '4px',
              mb: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            variant='h3'
            lineHeight={'15px'}
            fontWeight={'500'}
            fontSize={'16px'}
            color={selectedTab === 'general' ? '#202A2D' : '#655C68'}
            onClick={() => {
              navigate('/settings');
              setSelectedTab('general');
            }}
          >
            General Information
            <Box
              sx={{
                '@media (max-width: 900px)': {
                  display: 'none',
                },
              }}
            >
              <CaretRight
                size={24}
                color={selectedTab === 'general' ? '#202A2D' : '#655C68'}
              />
            </Box>
          </Typography>
          <Typography
            sx={{
              padding: '8px 10px',
              bgcolor: selectedTab === 'security' ? '#E5FAFF' : '',
              borderRadius: '4px',
              mb: '10px',
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            variant='h3'
            lineHeight={'15px'}
            fontWeight={'500'}
            fontSize={'16px'}
            color={selectedTab === 'security' ? '#202A2D' : '#655C68'}
            onClick={() => {
              setSelectedTab('security');
              navigate('/settings?tab=security');
            }}
          >
            Security
            <Box
              sx={{
                '@media (max-width: 900px)': {
                  display: 'none',
                },
              }}
            >
              <CaretRight
                size={24}
                color={selectedTab === 'security' ? '#202A2D' : '#655C68'}
              />
            </Box>
          </Typography>
        </Box>
        <Box
          ml={'75px'}
          sx={{
            maxWidth: '100%',
            width: '100%',
            '@media (max-width: 900px)': {
              ml: '0px',
            },
          }}
        >
          {selectedTab === 'general' ? <GeneralInformation /> : <Security />}
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
